<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="上游订单号：">
                <el-input v-model.trim="searchForm.upOrder" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="下游订单号：">
                <el-input v-model.trim="searchForm.downOrder" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="跨月类型：">
                <el-select v-model="searchForm.isNextMonth" clearable>
                    <el-option label="本月" value="0"></el-option>
                    <el-option label="次月" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="待确认" value="0"></el-option>
                    <el-option label="支付成功" value="1"></el-option>
                    <el-option label="支付失败" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="getListPageHandle">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  style="width:100%;" > 
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="170"></el-table-column>
            <el-table-column prop="upPackageName" label="上游套餐名" ></el-table-column>
            <el-table-column prop="downPackageName" label="下游套餐名" ></el-table-column>
            <el-table-column prop="upOrder" label="上游订单号" width="180"></el-table-column>
            <el-table-column prop="downOrder" label="下游订单号" width="180"></el-table-column>
            <el-table-column label="上游价格（元）" width="110">
                <template v-slot="scope">{{scope.row.upPrice/100}}</template>
            </el-table-column>
            <el-table-column label="下游价格（元）" width="110">
                <template v-slot="scope">{{scope.row.downPrice/100}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="下单时间" width="150"></el-table-column>
            <el-table-column prop="payTypeName" label="订单来源" ></el-table-column>
            <el-table-column label="支付状态" width="80">
                <template v-slot="scope">
                    <span style="color: blue;" v-if="scope.row.payState==0">待确认</span>
                    <span style="color: green;" v-else-if="scope.row.payState==1">支付成功</span>
                    <span style="color: red;" v-else>支付失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" ></el-table-column>
            <el-table-column label="操作" width="80">
                <template v-slot="scope" >
                    <el-button type="text" size="small" v-if="scope.row.payState == 2" @click="buyPkgReload(scope.row)">重 试</el-button>
                </template>                  
            </el-table-column>

        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        
    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                downOrder: '',
                upOrder: '',
                iccid: '',
                isNextMonth: '',
                payState:'',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('external/buy/pkg/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getListPageHandle();                
        },
        //重新购买
        buyPkgReload(rowData){
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo:rowData.downOrder,
                isNextMonth :rowData.isNextMonth,
                packgeId:rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        }

    
    },
    created () {
        this.getListPageHandle();
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

